import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import SupplierTable from "../components/SupplierTable";
import { getPageName } from "../../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import NavBar, { NavBarItem } from "../../../components/NavBar";
import { GridColDef } from "@mui/x-data-grid";
import AlertOverlay from "../../../components/Alert";
import { useSupplier } from "../../../apis/supplier/SupplierProvider";
import Paginacao from "../../../types/paginacao";
import Supplier from "../../../types/supplier";
import { FaEdit } from "react-icons/fa";

const SupplierView: React.FC = () => {
    const { t } = useTranslation();
    const { suppliers, apiResponse, fetchSuppliers } = useSupplier();
    const navigate = useNavigate();
    const location = useLocation();
    const [alert, setAlert] = useState<{ message: string; variant: "success" | "danger" | "warning" | "info" } | null>(null);

    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 20,
        page: 0,
    });

    const [paginacao, setPaginacao] = React.useState({
        pageNum: 0,
        quantityPerPage: 20
    } as Paginacao);
    
    useEffect(() => {
        const newPaginacao = {
            ...paginacao, 
            pageNum: paginationModel.page,
            quantityPerPage: paginationModel.pageSize
        };
        setPaginacao(newPaginacao);
        fetchSuppliers(newPaginacao);
    }, [paginationModel]);

    useEffect(() => {
        if (location.state?.message) {
            setAlert({ message: location.state.message, variant: location.state.variant });
    
            navigate(location.pathname, { replace: true });
    
            const timeout = setTimeout(() => setAlert(null), 5000);
            return () => clearTimeout(timeout);
        }
    }, [location, navigate]);
     
    const navItems: NavBarItem[] = [
        { label: t('supplier.labels.home'), route: "/", iconName: "house-door" },
        { label: t('supplier.labels.new'), route: "/Supplier/create", iconName: "plus-circle" },
    ];

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: t('supplier.fields.id'),
            width: 80,
            renderCell: (params) => (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "black",
                    cursor: "pointer"
                }}
                onClick={() => navigate(`/supplier/${params.row.id}`)}>
                    <FaEdit className="text-primary" style={{ marginRight: "6px", marginLeft: "2px" }}/>
                    {params.row.id}
                </span>
            ),
        },
        // { field: "cnpj", headerName: t('supplier.fields.cnpj'), width: 200 },
        { field: "name", headerName: t('supplier.fields.name'), width: 350 },
        { 
            field: "client", 
            headerName: t('supplier.fields.client'), 
            width: 350,
            valueGetter: (client: any) => {
                return client?.name
            } 
        },
    ];

    return (
         <Container fluid style={{ height: 'calc(100vh - 200px)', overflow: 'auto' }}>
            <NavBar items={navItems} />
            <div className="mb-3"></div>
            <h2>{getPageName("supplier")}</h2>
            <div className="mb-3"></div>
            <div>
            {alert && (
                <AlertOverlay
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert(null)}
                />
            )}
        </div>
            <SupplierTable
                rows={suppliers || [] as Supplier[]}
                columns={columns}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row")}
                apiResponse={apiResponse} 
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
            />
        </Container>
    );
};

export default SupplierView;